import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Bike, Check, Loader2, MapPin, Store } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function CourierShell({ children }) {
  return (
    <div className="grain flex min-h-screen items-start justify-center p-4 pt-10">
      <div className="card-surface w-full max-w-sm space-y-5 p-6">{children}</div>
    </div>
  );
}

export const OrderHead = ({ d }) => (
  <div className="space-y-2">
    <p className="flex items-center gap-2 text-xs text-muted-foreground"><Store className="h-4 w-4" />{d.store}</p>
    <p className="text-2xl font-bold">Pedido #{d.number}</p>
    <p className="flex items-start gap-2 text-sm"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />{d.address}</p>
  </div>
);

export default function CourierRun() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/courier/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  const arrive = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/courier/${token}/arrived`);
      setD(data);
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  if (err) return <CourierShell><p className="text-center text-sm text-muted-foreground" data-testid="courier-run-error">{err}</p></CourierShell>;
  if (!d) return <CourierShell><p className="flex justify-center"><Loader2 className="h-6 w-6 animate-spin" /></p></CourierShell>;
  const arrived = d.step && d.step !== "accepted";
  return (
    <CourierShell>
      <OrderHead d={d} />
      {arrived ? (
        <p className="flex items-start gap-2 rounded-md bg-emerald-500/10 p-3 text-sm text-emerald-700 dark:text-emerald-300" data-testid="courier-arrived-msg">
          <Check className="mt-0.5 h-4 w-4 shrink-0" />Pronto! Enviamos o código de coleta no seu WhatsApp. Abra o link para mostrar o código à loja.
        </p>
      ) : <p className="text-sm text-muted-foreground">Quando chegar na loja, toque no botão abaixo.</p>}
      <Button className="h-14 w-full text-base font-semibold" onClick={arrive} disabled={busy} data-testid="courier-arrived-btn">
        {busy ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : <Bike className="mr-2 h-5 w-5" />}{arrived ? "Reenviar código no WhatsApp" : "Cheguei na loja"}
      </Button>
    </CourierShell>
  );
}
